import { jsx } from "react/jsx-runtime";
const TableFilledIcon = (props) => /* @__PURE__ */ jsx("svg", { ...props, viewBox: "0 0 1024 1024", children: /* @__PURE__ */ jsx(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96 160H928C945.7 160 960 174.3 960 192V832C960 849.7 945.7 864 928 864H96C78.3 864 64 849.7 64 832V192C64 174.3 78.3 160 96 160ZM676 368H888V432H676V592H888V656H676V792H612V656H412V792H348V656H136V592H348V432H136V368H348V232H412V368H612V232H676V368ZM412 432H612V592H412V432Z"
  }
) });
export {
  TableFilledIcon
};
